export default "__VITE_ASSET__DPC$k_0W__"